import Dialog from "components/dialog";

import { filtersText } from "utils/metadata";

type OverrideDialogProps = {
  currentFilters: any;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function OverrideDialog(
  props: OverrideDialogProps
): JSX.Element {
  const { currentFilters } = props;
  const { onConfirm, onCancel } = props;

  return (
    <Dialog
      title="Uma nova prova será gerada"
      confirmText="Continuar"
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      <p className="dialog-text">
        Você começou a responder um simulado ({filtersText(currentFilters)}) e
        vai perder as respostas que marcou. Quer continuar assim mesmo?
      </p>
    </Dialog>
  );
}
